import { defineMessages } from 'react-intl'

export default defineMessages({
  insurance_details_not_provided: {
    id: 'eligibilityerror.insurance_details_not_provided',
    defaultMessage: 'Insurance details not provided',
  },
  member_details_mismatch: {
    id: 'eligibilityerror.member_details_mismatch',
    defaultMessage: `{person, select,
      first {We could not find your insurance coverage. Please check that the following details are correct: 
        \n - First name
        \n - Last name
        \n - Date of birth}
      other {We could not find their insurance coverage. Please check that the following details are correct: 
        \n - First name
        \n - Last name
        \n - Date of birth}
      }`,
  },
  insurance_details_mismatch: {
    id: 'eligibilityerror.insurance_details_mismatch',
    defaultMessage: `{person, select,
      first {We could not find your insurance coverage. Please check that your member ID matches your insurance or benefits card.}
      other {We could not find their insurance coverage. Please check that the member ID matches their insurance or benefits card. }
    }`,
  },
  coverage_inactive: {
    id: 'eligibilityerror.coverage_inactive',
    defaultMessage: `{person, select,
      first {Your insurance is not active. You need to activate it to access appointments}
      other {{name}’s insurance is not active. You need to activate it to access appointments}
    }`,
  },
  coverage_expired: {
    id: 'eligibilityerror.coverage_expired',
    defaultMessage: `{person, select,
      first {Your insurance has expired. You need to renew it to access appointments}
      other {{name}’s insurance has expired. You need to renew it to access appointments}
    }`,
  },
  coverage_will_expire: {
    id: 'eligibilityerror.coverage_will_expire',
    defaultMessage: `{person, select,
      first {Your insurance is due to expire soon. You need to renew it to access appointments after this time}
      other {{name}’s insurance is due to expire soon. You need to renew it to access appointments after this time}
    }`,
  },
  coverage_not_started: {
    id: 'eligibilityerror.coverage_not_started',
    defaultMessage: `{person, select,
      first {Your insurance coverage hasn’t started yet. You won’t be able to book appointments until it starts}
      other {{name}’s insurance coverage hasn’t started yet. You won’t be able to book appointments until it starts}
    }`,
  },
  service_not_covered: {
    id: 'eligibilityerror.service_not_covered',
    defaultMessage: `{person, select,
      first {Your insurance doesn't cover our services, but it may cover your children's or dependents.}
      other {{name} isn’t covered for Babylon services by their insurance}
    }`,
  },
  unknown_reason: {
    id: 'eligibilityerror.unknown_reason',
    defaultMessage: `{person, select,
      first {You’re not eligible for Babylon services with your insurance}
      other {{name} is not eligible for Babylon services with their insurance}
    }`,
  },
})
